import { css } from '@emotion/css';
import { Tabs, TabsProps, Tooltip } from 'antd';
import {
  useCreateTrigger,
  useSetTriggerValue,
  useTriggerMapValue,
} from 'hooks/business/useTrigger';
import { useGetPermission } from 'hooks/business/useNewPermisson';
import { ChatNav } from './ChatNav';
import { ReturnNav } from './ReturnNav';
import { ReviewNav } from './ReviewNav';
import TodoNav from './TodoNav';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { isQuickChat } from 'productLine';
import { MercadoNav } from './MercadoNav';
import { Expand } from 'lucide-react';
import { useTranslate } from '@tolgee/react';
import { useSetFocusMode } from 'hooks/useFocusMode';

const tabCls = css`
  margin-top: 8px;
  margin-left: 8px;
  &.ant-tabs-top.ant-tabs-card {
    .ant-tabs-nav {
      margin-bottom: 0;
      .ant-tabs-nav-list {
        .ant-tabs-tab {
          margin: 0;
          border: none;
          background-color: unset;
        }
        .ant-tabs-tab-active {
          background-color: #ffffff;
        }
      }
    }

    .ant-badge-count {
      border-radius: 4px;
    }
  }
`;

const HorizontalNav = ({ activeKey, onChange }: Pick<TabsProps, 'activeKey' | 'onChange'>) => {
  const { whiteListConfig: { TODO_MANAGEMENT_CENTER = false } = {} } = useOrgConfigStateValue();

  const { t } = useTranslate();
  const getPermission = useGetPermission();
  const mercadoEnable = getPermission('基础聊天权限', { platform: 'MERCADO' });
  const refundEnable = getPermission('弃单处理页面');
  const reviewEnable = getPermission('访问评价聚合页');
  const todoEnable = TODO_MANAGEMENT_CENTER && getPermission('访问待办管理中心');

  const { REVIEWGUIDE } = useTriggerMapValue();

  const setTriggerValue = useSetTriggerValue();

  const createTrigger = useCreateTrigger();

  const clearReviewGuide = () => {
    setTriggerValue((value) => [...value, 'REVIEWGUIDE']);

    createTrigger({
      trigger: 'REVIEWGUIDE',
    });
  };

  const setFocusMode = useSetFocusMode();

  return (
    <Tabs
      type="card"
      className={tabCls}
      activeKey={activeKey}
      onChange={(key) => {
        onChange?.(key);

        if (key === 'review' && !REVIEWGUIDE) {
          clearReviewGuide();
        }
      }}
      tabBarExtraContent={
        <Tooltip title={t('app.config.focusMode.open.tips')} placement="left">
          <div
            className="mx-4 text-[#888888] cursor-pointer inline-flex items-center justify-center"
            onClick={() => setFocusMode(true)}
          >
            <Expand size={16} />
          </div>
        </Tooltip>
      }
    >
      <Tabs.TabPane tab={<ChatNav />} key="conversation" />
      {refundEnable && <Tabs.TabPane tab={<ReturnNav />} key="refund" />}
      {reviewEnable && <Tabs.TabPane tab={<ReviewNav />} key="review" />}
      {todoEnable && !isQuickChat && <Tabs.TabPane tab={<TodoNav />} key="todo" />}
      {mercadoEnable && <Tabs.TabPane tab={<MercadoNav />} key="mercado-faq" />}
    </Tabs>
  );
};

export default HorizontalNav;
